<template>
    <div class="d-flex flex-row product-line">
        <div class="px-2 mb-1 text-center product-image">
            <a :href="product.link" :title="product.name">
                <img :src="product.thumbnail" :title="product.name" />
            </a>
        </div>
        <div class="flex-fill product-name">
            <div class="row">
                <div class="col product-title">
                    <a :href="product.link" :title="product.name">
                        {{ product.name.length > 27 ? product.name.substring(0, 27).trim() + '...' : product.name }}
                    </a>
                </div>
            </div>
            <div class="row product-attributes" v-if="$root.mobile === false">
                <div class="col-auto align-self-center pr-0" v-if="this.product.attributes.length > 0">
                    <variant-selector :product="product" @changeAttributes="updateAttributes"></variant-selector>
                </div>
                <div class="col align-self-center d-desktop-only">
                    <availability v-if="selectedProduct" :product="selectedProduct" />
                </div>
            </div>
        </div>
        <div class="align-self-center text-right pr-1 product-price">
            {{ product.formattedPrices.price}}
        </div>
        <div class="col-2 align-self-center pl-1 product-button">
            <button v-if="selectedCombination !== undefined" @click="addProduct">{{ translations['Add'] }}</button>
        </div>
    </div>
</template>
<script>
    import Availability from "./Availability";
    import VariantSelector from "./VariantSelector";
    import { mapState } from 'vuex';

    export default {
        components: {VariantSelector, Availability},
        props: ['product'],
        data () {
            return {
                selectedAttributes: []
            }
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
            }),
            selectedProduct: function () {
                if (this.selectedCombination === undefined) {
                    return;
                }
                return {
                    ...this.product,
                    id_attribute: this.selectedCombination
                }
            },
            selectedCombination: function () {
                let ids = {};
                let combinations = [];

                if (this.product.attributes.length === 0) {
                    return 0
                }

                if (this.selectedAttributes.length !== this.product.attributes.length) {
                    return
                }

                for (let index in this.selectedAttributes) {
                    if (this.selectedAttributes.hasOwnProperty(index) === false) {
                        continue;
                    }
                    const attributeId = this.selectedAttributes[index].attributeId;
                    const groupId = this.selectedAttributes[index].groupId;
                    let found = this.product.combinations.filter(item => {
                        return item.attribute === attributeId && item.group === groupId
                    });
                    combinations = [...combinations, ...found];
                    found.forEach(item => {
                        if (ids[item.id] === undefined) {
                            ids[item.id] = []
                        }
                        ids[item.id].push(item)
                    })
                }

                let selectedId;
                for (let i in ids) {
                    if (ids[i].length !== this.selectedAttributes.length) {
                        continue;
                    }
                    selectedId = i;
                }
                return selectedId
            }
        },
        methods: {
            addProduct: function () {
                this.$store.dispatch('ADD_PRODUCT', {
                    id: this.product.id,
                    id_attribute: this.selectedCombination,
                    quantity: 1
                });
            },
            updateAttributes: function (attribute) {
                const index = this.selectedAttributes.findIndex(item => {
                    return item.groupId === attribute.groupId;
                });
                if (index !== -1) {
                    this.selectedAttributes.splice(index, 1);
                }
                this.selectedAttributes.push(attribute)
            }
        },
        mounted() {
            if (this.selectedAttributes.length > 0) {
                return;
            }
            this.product.attributes.forEach(item => {
                this.updateAttributes({
                    groupId: item.id,
                    attributeId: item.values[Object.keys(item.values)[0]].id,
                })
            })
        }
    }
</script>

<style scoped lang="scss">
    .product-line {
        padding: 16px 0;
        border-bottom: 2px solid #f4f4f4;

        @media (min-width: 1350px) {
            opacity: 0.7;
        }

        &:hover {
            opacity: 1;
        }

        .product-image {
            img {
                height: 100%;
                max-height: 50px;
            }
        }

        .product-title {
            font-size: 18px;
            font-weight: 700;
            text-transform: uppercase;
        }

        .product-price {
            font-size: 24px;
            font-weight: 700;
        }

        .product-button {
            padding-left: 10px;
            button {
                border: none;
                border-radius: 4px;
                background-color: #f2b508;
                color: #ffffff;
                text-transform: uppercase;
                font-size: 15px;
                font-weight: 700;
                padding: 8px 16px;
            }
        }

        @media (max-width: 1349px) {
            flex-wrap: wrap;
            padding: 0;

            .product-title {
                font-size: 14px;
            }
            .product-image{
                flex: 1 0 100%;
                img{
                    max-height: unset;
                    height: unset;
                    max-width: 100%;
                    width: 110px;
                }
            }
            .product-name{
                flex: 1 0 100%;
                text-align: center;
                .product-attributes{
                    flex: 1 0 49%;
                    margin: 10px 0;
                }
                .product-title{
                    a{
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        line-height: 21px;
                        max-height: 63px;
                    }
                }
            }
            .product-price{
                flex: 1 0 49%;
                max-width: 50%;
                color: #6eb540;
                white-space: nowrap;
                font-size: 14px;
                padding-left: 5px;
            }
            .product-button{
                flex: 1 0 49%;
                max-width: 50%;
                padding-right: 0;
                padding-left: 0;
                button{
                    font-size: 9px  ;
                    background: #6eb540;
                    padding: 4px 12px;
                    border-radius: 2px;

                    &:hover {
                        background: #2d7900;
                    }

                    &:focus {
                        outline: none;
                    }
                }
            }
        }
    }
</style>
